import request from './request';
import config from './config';

var moment = require('moment');

let PageRecord={
    old_time : null, //进入页面的时间 (时间戳)
    jump_num : 0, //跳转次数
    page_from: sessionStorage.getItem('PAGEFROM')||'main_page', //页面来源
    now_page: '', //当前页面
    init(){
        this.old_time = moment().valueOf()
        if(config.SystemOS=='IOS'){
            // 设置是IOS则监听'pagehide'
            window.addEventListener("pagehide",()=>{
                this.BeforeUnloadRecord()
            },false)
        }else{
            // 关闭页面前的发送一次 安卓刷新时触发
            window.addEventListener('beforeunload',()=>{
                this.BeforeUnloadRecord()
            },false)
        }
    },
    // 刷新和退出页面时的传值策略
    BeforeUnloadRecord(){
        if( this.now_page && this.page_from ){
            if(this.page_from == 'null' || this.page_from == 'undefined' || this.page_from == ''){
                this.page_from = 'main_page'
            }
            var i = new Image();
            let url = process.env.VUE_APP_BASE_API+`/h5/PageRecord/inH5Record?`
            url += `page_name=${this.now_page}`
            url += `&page_from=${this.page_from}`
            url += `&page_time=${((moment().valueOf() - this.old_time)/1000).toFixed(2)}`
            url += `&receiver_id=${sessionStorage.getItem('page_record_receiver_id')||''}`
            url += `&sms_code=${sessionStorage.getItem('sms_code')||''}`
            url += `&token=${sessionStorage.getItem('x-token')||''}`
            url += `&v_id=${sessionStorage.getItem('v_id')||''}`
            i.src = url
        }
    },
    // 切换页面时的监听策略
    async post_record(params){
        this.now_page = params.now_page // 留存当前页面信息
        delete params.now_page // 留存当前页面信息后删除多余参数
        // 整理参数
        let now_time = moment().valueOf()
        let 滞留时间 =  ((now_time-this.old_time)/1000).toFixed(2)
        this.old_time = now_time
        if(滞留时间 > 0.01 && this.page_from){
            if(this.page_from == 'null' || this.page_from == 'undefined' || this.page_from == ''){
                this.page_from = 'main_page'
            }
            // 调整参数
            params.page_time = 滞留时间 //停留时间
            params.page_from = this.page_from //页面来源
            params.receiver_id = sessionStorage.getItem('page_record_receiver_id') //接收人id
            // 记录页面作为来源
            await request({
                url: "/h5/PageRecord/inH5Record",
                method: "post",
                params,
            })
            sessionStorage.setItem('PAGEFROM',params.page_name) // 存储用于刷新时的页面来源
            this.page_from = params.page_name||this.page_from
        }
    },
}
export default PageRecord;